import { useEffect, useState } from 'react';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/personel';
const token = () => localStorage.getItem('token');
const hdr = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` });

const TUR_RENK: Record<string, { renk: string; bg: string }> = {
  kadrolu:    { renk: '#1e40af', bg: '#dbeafe' },
  sozlesmeli: { renk: '#065f46', bg: '#d1fae5' },
  isci:       { renk: '#92400e', bg: '#fef3c7' },
};

const BOŞ_KADRO = {
  yil: new Date().getFullYear(), unvan_id: '', isletme_id: '',
  birim_adi: '', toplam_adet: 0, dolu_adet: 0, aciklama: '',
};

export default function PersonelKadro() {
  const [liste, setListe] = useState<any[]>([]);
  const [unvanlar, setUnvanlar] = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [ozet, setOzet] = useState<any>({});
  const [form, setForm] = useState<any>(null);
  const [unvanForm, setUnvanForm] = useState<any>(null);
  const [filtreyil, setFiltreyil] = useState(new Date().getFullYear());
  const [filtreIsletme, setFiltreIsletme] = useState<string>('');
  const [sekme, setSekme] = useState<'pozisyon' | 'unvan'>('pozisyon');

  useEffect(() => {
    yukle();
    fetch(`${API}/unvanlar`, { headers: hdr() }).then(r => r.json()).then(setUnvanlar);
    fetch((process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/isletmeler', { headers: hdr() }).then(r => r.json()).then(d => setIsletmeler(Array.isArray(d) ? d : d.isletmeler || []));
  }, []);

  function yukle(yil = filtreyil, isletme = filtreIsletme) {
    const p = new URLSearchParams({ yil: String(yil) });
    if (isletme) p.set('isletme_id', isletme);
    fetch(`${API}/kadro?${p}`, { headers: hdr() }).then(r => r.json()).then(setListe);
    fetch(`${API}/kadro/ozet?yil=${yil}`, { headers: hdr() }).then(r => r.json()).then(setOzet);
  }

  async function kaydetKadro() {
    const method = form.id ? 'PUT' : 'POST';
    const url = form.id ? `${API}/kadro/${form.id}` : `${API}/kadro`;
    const veri = { ...form, yil: Number(form.yil), toplam_adet: Number(form.toplam_adet), dolu_adet: Number(form.dolu_adet) };
    if (!veri.isletme_id) veri.isletme_id = null;
    if (!veri.unvan_id) return alert('Unvan seçiniz');
    veri.unvan_id = Number(veri.unvan_id);
    await fetch(url, { method, headers: hdr(), body: JSON.stringify(veri) });
    setForm(null);
    yukle();
  }

  async function silKadro(id: number) {
    if (!confirm('Bu pozisyonu silmek istiyor musunuz?')) return;
    await fetch(`${API}/kadro/${id}`, { method: 'DELETE', headers: hdr() });
    yukle();
  }

  async function kaydetUnvan() {
    const method = unvanForm.id ? 'PUT' : 'POST';
    const url = unvanForm.id ? `${API}/unvanlar/${unvanForm.id}` : `${API}/unvanlar`;
    const veri = { ...unvanForm, min_derece: Number(unvanForm.min_derece), max_derece: Number(unvanForm.max_derece) };
    await fetch(url, { method, headers: hdr(), body: JSON.stringify(veri) });
    setUnvanForm(null);
    fetch(`${API}/unvanlar`, { headers: hdr() }).then(r => r.json()).then(setUnvanlar);
  }

  // Grafik: yüzde doluluk
  const dolulukYuzdesi = ozet.toplam > 0 ? Math.round((ozet.dolu / ozet.toplam) * 100) : 0;

  // İşletme bazlı grupla
  const gruplar: Record<string, any[]> = {};
  liste.forEach(r => {
    const key = r.isletme_id ? `İşletme #${r.isletme_id}` : 'Merkez';
    if (!gruplar[key]) gruplar[key] = [];
    gruplar[key].push(r);
  });

  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#111827' }}>Kadro & Pozisyon Envanteri</h2>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>Dolu / Boş kadro takibi — yıl bazlı</p>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={() => setSekme(sekme === 'pozisyon' ? 'unvan' : 'pozisyon')} style={{
            background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 8,
            padding: '8px 16px', cursor: 'pointer', fontSize: 13, fontWeight: 600,
          }}>
            {sekme === 'pozisyon' ? '📋 Unvan Tanımları' : '📊 Pozisyon Listesi'}
          </button>
          <button onClick={() => sekme === 'pozisyon' ? setForm({ ...BOŞ_KADRO }) : setUnvanForm({ kod: '', ad: '', personel_turu: 'kadrolu', hizmet_sinifi: '', cetvel: '', min_derece: 1, max_derece: 15, aciklama: '', aktif: true })} style={{
            background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8,
            padding: '8px 16px', cursor: 'pointer', fontWeight: 600, fontSize: 13,
          }}>+ Ekle</button>
        </div>
      </div>

      {sekme === 'pozisyon' && (
        <>
          {/* ÖZET KARTLAR */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 20 }}>
            <OzetKart label="Toplam Kadro" deger={ozet.toplam || 0} renk="#1d4ed8" bg="#eff6ff" />
            <OzetKart label="Dolu" deger={ozet.dolu || 0} renk="#065f46" bg="#ecfdf5" />
            <OzetKart label="Boş" deger={ozet.bos || 0} renk="#991b1b" bg="#fef2f2" />
            <div style={{ background: '#f9fafb', borderRadius: 10, padding: '14px 18px', border: '1px solid #e5e7eb' }}>
              <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 8 }}>Doluluk Oranı</div>
              <div style={{ background: '#e5e7eb', borderRadius: 999, height: 10, overflow: 'hidden' }}>
                <div style={{ width: `${dolulukYuzdesi}%`, height: '100%', background: dolulukYuzdesi > 80 ? '#065f46' : dolulukYuzdesi > 50 ? '#d97706' : '#991b1b', borderRadius: 999, transition: 'width 0.5s' }} />
              </div>
              <div style={{ fontSize: 16, fontWeight: 700, color: '#111827', marginTop: 6 }}>{dolulukYuzdesi}%</div>
            </div>
          </div>

          {/* FİLTRELER */}
          <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
            <input type="number" value={filtreyil} onChange={e => { setFiltreyil(Number(e.target.value)); yukle(Number(e.target.value), filtreIsletme); }} style={selectSt} />
            <select value={filtreIsletme} onChange={e => { setFiltreIsletme(e.target.value); yukle(filtreyil, e.target.value); }} style={selectSt}>
              <option value="">Merkez + Tüm İşletmeler</option>
              <option value="0">Merkez</option>
              {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
            </select>
          </div>

          {/* GRUPLU LİSTE */}
          {Object.entries(gruplar).map(([grup, satırlar]) => (
            <div key={grup} style={{ marginBottom: 20 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#374151', marginBottom: 8, padding: '6px 12px', background: '#f3f4f6', borderRadius: 8 }}>
                {grup} — {satırlar.length} pozisyon türü
              </div>
              <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                      {['Unvan', 'Birim', 'Tür', 'Toplam', 'Dolu', 'Boş', 'Doluluk', ''].map(h => (
                        <th key={h} style={{ padding: '9px 14px', textAlign: 'left', fontWeight: 600, color: '#374151', fontSize: 12 }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {satırlar.map((r, i) => {
                      const yuzde = r.toplam_adet > 0 ? Math.round((r.dolu_adet / r.toplam_adet) * 100) : 0;
                      const unvan = unvanlar.find(u => u.id === r.unvan_id);
                      const tur = TUR_RENK[unvan?.personel_turu || ''] || { renk: '#374151', bg: '#f3f4f6' };
                      return (
                        <tr key={r.id} style={{ borderBottom: '1px solid #f3f4f6', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                          <td style={{ padding: '9px 14px', fontWeight: 600 }}>{r.unvan_adi}</td>
                          <td style={{ padding: '9px 14px', color: '#6b7280', fontSize: 12 }}>{r.birim_adi || '—'}</td>
                          <td style={{ padding: '9px 14px' }}>
                            <span style={{ background: tur.bg, color: tur.renk, fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 6 }}>
                              {unvan?.personel_turu || '—'}
                            </span>
                          </td>
                          <td style={{ padding: '9px 14px', textAlign: 'center', fontWeight: 700 }}>{r.toplam_adet}</td>
                          <td style={{ padding: '9px 14px', textAlign: 'center', color: '#065f46', fontWeight: 700 }}>{r.dolu_adet}</td>
                          <td style={{ padding: '9px 14px', textAlign: 'center', color: r.bos_adet > 0 ? '#991b1b' : '#374151', fontWeight: 700 }}>{r.bos_adet}</td>
                          <td style={{ padding: '9px 14px', minWidth: 100 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                              <div style={{ flex: 1, background: '#e5e7eb', borderRadius: 999, height: 6, overflow: 'hidden' }}>
                                <div style={{ width: `${yuzde}%`, height: '100%', background: yuzde > 80 ? '#065f46' : yuzde > 50 ? '#d97706' : '#991b1b', borderRadius: 999 }} />
                              </div>
                              <span style={{ fontSize: 11, color: '#6b7280', minWidth: 28 }}>{yuzde}%</span>
                            </div>
                          </td>
                          <td style={{ padding: '9px 14px' }}>
                            <div style={{ display: 'flex', gap: 6 }}>
                              <button onClick={() => setForm({ ...r })} style={kücükBtnSt}>Düzenle</button>
                              <button onClick={() => silKadro(r.id)} style={{ ...kücükBtnSt, color: '#991b1b', borderColor: '#fecaca' }}>Sil</button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
          {liste.length === 0 && <div style={{ textAlign: 'center', color: '#9ca3af', padding: 40 }}>Kadro verisi bulunamadı. Pozisyon ekleyiniz.</div>}
        </>
      )}

      {sekme === 'unvan' && (
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                {['Kod', 'Unvan Adı', 'Personel Türü', 'Hizmet Sınıfı / Cetvel', 'Derece Aralığı', ''].map(h => (
                  <th key={h} style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: '#374151', fontSize: 12 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {unvanlar.map((u, i) => {
                const tur = TUR_RENK[u.personel_turu] || { renk: '#374151', bg: '#f3f4f6' };
                return (
                  <tr key={u.id} style={{ borderBottom: '1px solid #f3f4f6', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={{ padding: '9px 14px', fontWeight: 700, color: '#1d4ed8', fontFamily: 'monospace' }}>{u.kod}</td>
                    <td style={{ padding: '9px 14px', fontWeight: 600 }}>{u.ad}</td>
                    <td style={{ padding: '9px 14px' }}>
                      <span style={{ background: tur.bg, color: tur.renk, fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 6 }}>{u.personel_turu}</span>
                    </td>
                    <td style={{ padding: '9px 14px', color: '#374151', fontSize: 12 }}>
                      {u.hizmet_sinifi || ''}{u.cetvel ? ` / ${u.cetvel}. Cetvel` : ''}
                    </td>
                    <td style={{ padding: '9px 14px', fontFamily: 'monospace', fontSize: 12 }}>{u.min_derece}–{u.max_derece}</td>
                    <td style={{ padding: '9px 14px' }}>
                      <button onClick={() => setUnvanForm({ ...u })} style={kücükBtnSt}>Düzenle</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* POZISYON FORM */}
      {form && (
        <Modal baslik={form.id ? 'Pozisyonu Düzenle' : 'Yeni Kadro Pozisyonu'} kapat={() => setForm(null)}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
            <Alan etiket="Yıl *">
              <input type="number" value={form.yil} onChange={e => setForm({ ...form, yil: e.target.value })} style={inputSt} />
            </Alan>
            <Alan etiket="Unvan *">
              <select value={form.unvan_id} onChange={e => setForm({ ...form, unvan_id: e.target.value })} style={selectSt}>
                <option value="">Seçiniz</option>
                {unvanlar.map(u => <option key={u.id} value={u.id}>{u.ad}</option>)}
              </select>
            </Alan>
            <Alan etiket="İşletme (boş=Merkez)">
              <select value={form.isletme_id || ''} onChange={e => setForm({ ...form, isletme_id: e.target.value })} style={selectSt}>
                <option value="">Merkez</option>
                {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
              </select>
            </Alan>
            <Alan etiket="Birim Adı">
              <input value={form.birim_adi} onChange={e => setForm({ ...form, birim_adi: e.target.value })} style={inputSt} />
            </Alan>
            <Alan etiket="Toplam Kadro">
              <input type="number" min={0} value={form.toplam_adet} onChange={e => setForm({ ...form, toplam_adet: e.target.value })} style={inputSt} />
            </Alan>
            <Alan etiket="Dolu Kadro">
              <input type="number" min={0} value={form.dolu_adet} onChange={e => setForm({ ...form, dolu_adet: e.target.value })} style={inputSt} />
            </Alan>
            <Alan etiket="Açıklama" tam>
              <textarea value={form.aciklama} onChange={e => setForm({ ...form, aciklama: e.target.value })} style={{ ...inputSt, height: 60, resize: 'vertical' }} />
            </Alan>
          </div>
          <ModalButonlar kapat={() => setForm(null)} kaydet={kaydetKadro} />
        </Modal>
      )}

      {/* UNVAN FORM */}
      {unvanForm && (
        <Modal baslik={unvanForm.id ? 'Unvan Düzenle' : 'Yeni Unvan Tanımı'} kapat={() => setUnvanForm(null)}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
            <Alan etiket="Kod *"><input value={unvanForm.kod} onChange={e => setUnvanForm({ ...unvanForm, kod: e.target.value })} style={inputSt} /></Alan>
            <Alan etiket="Unvan Adı *"><input value={unvanForm.ad} onChange={e => setUnvanForm({ ...unvanForm, ad: e.target.value })} style={inputSt} /></Alan>
            <Alan etiket="Personel Türü">
              <select value={unvanForm.personel_turu} onChange={e => setUnvanForm({ ...unvanForm, personel_turu: e.target.value })} style={selectSt}>
                <option value="kadrolu">657 Kadrolu</option>
                <option value="sozlesmeli">399 KHK Sözleşmeli</option>
                <option value="isci">4857 İşçi</option>
              </select>
            </Alan>
            <Alan etiket="Hizmet Sınıfı">
              <select value={unvanForm.hizmet_sinifi} onChange={e => setUnvanForm({ ...unvanForm, hizmet_sinifi: e.target.value })} style={selectSt}>
                <option value="">Seçiniz</option>
                {['GİH', 'TH', 'SH', 'AH', 'EH', 'DH', 'KİT'].map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </Alan>
            <Alan etiket="Cetvel (399 KHK)">
              <select value={unvanForm.cetvel || ''} onChange={e => setUnvanForm({ ...unvanForm, cetvel: e.target.value })} style={selectSt}>
                <option value="">Yok</option>
                <option value="I">I. Cetvel</option>
                <option value="II">II. Cetvel</option>
              </select>
            </Alan>
            <div style={{ display: 'flex', gap: 8 }}>
              <Alan etiket="Min Derece"><input type="number" min={1} max={15} value={unvanForm.min_derece} onChange={e => setUnvanForm({ ...unvanForm, min_derece: e.target.value })} style={{ ...inputSt, width: '100%' }} /></Alan>
              <Alan etiket="Max Derece"><input type="number" min={1} max={15} value={unvanForm.max_derece} onChange={e => setUnvanForm({ ...unvanForm, max_derece: e.target.value })} style={{ ...inputSt, width: '100%' }} /></Alan>
            </div>
          </div>
          <ModalButonlar kapat={() => setUnvanForm(null)} kaydet={kaydetUnvan} />
        </Modal>
      )}
    </div>
  );
}

function OzetKart({ label, deger, renk, bg }: { label: string; deger: number; renk: string; bg: string }) {
  return (
    <div style={{ background: bg, borderRadius: 10, padding: '14px 18px', border: '1px solid #e5e7eb' }}>
      <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 28, fontWeight: 700, color: renk }}>{deger}</div>
    </div>
  );
}

function Modal({ baslik, kapat, children }: { baslik: string; kapat: () => void; children: React.ReactNode }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 14, padding: 28, width: 620, maxHeight: '90vh', overflow: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>{baslik}</h3>
          <button onClick={kapat} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#9ca3af' }}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

function ModalButonlar({ kapat, kaydet }: { kapat: () => void; kaydet: () => void }) {
  return (
    <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>
      <button onClick={kapat} style={{ padding: '9px 20px', border: '1px solid #d1d5db', borderRadius: 8, background: '#f3f4f6', color: '#374151', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
      <button onClick={kaydet} style={{ padding: '9px 20px', border: 'none', borderRadius: 8, background: '#1d4ed8', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>Kaydet</button>
    </div>
  );
}

function Alan({ etiket, tam, children }: { etiket: string; tam?: boolean; children: React.ReactNode }) {
  return (
    <div style={{ gridColumn: tam ? '1 / -1' : undefined }}>
      <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>{etiket}</label>
      {children}
    </div>
  );
}

const inputSt: React.CSSProperties = { width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 7, fontSize: 13, boxSizing: 'border-box' };
const selectSt: React.CSSProperties = { ...inputSt, background: '#fff' };
const kücükBtnSt: React.CSSProperties = { background: 'none', border: '1px solid #d1d5db', borderRadius: 6, padding: '3px 10px', cursor: 'pointer', fontSize: 12, color: '#374151' };
